
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"label":"Attribute settings (workbook)"},"de":{"label":"Attributeinstellungen (Arbeitsmappe)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();